import { OrganizationType } from "@/types/domain";
import type { FinancierItem } from "@/types/api/financier";
import type { MerchantItem } from "@/types/api/merchant";
import { useCurrentOrganization } from "./useCurrentOrganization";
import { useFinancierById } from "./useFinancierById";
import { useMerchantById } from "./useMerchantById";

export function useCurrentEntityDetail(): {
  data: MerchantItem | FinancierItem | undefined;
  isLoading: boolean;
  } {
  const { data: organization, isLoading: orgLoading } = useCurrentOrganization();
  const isMerchant = organization?.externalEntityType === OrganizationType.Merchant;
  const isFinancier = organization?.externalEntityType === OrganizationType.Financier;

  const { data: merchant, isLoading: merchantLoading } = useMerchantById(
    isMerchant ? (organization?.externalEntityId ?? undefined) : undefined
  );
  const { data: financier, isLoading: financierLoading } = useFinancierById(
    isFinancier ? (organization?.externalEntityId ?? undefined) : undefined
  );

  return {
    data: merchant ?? financier,
    isLoading: orgLoading || merchantLoading || financierLoading,
  };
}
